import { useMutation, useApiQueryClient } from '@sequencehq/api/utils'
import { dashboardv99990101Client } from '@sequencehq/api/dashboard/v99990101'
import { useNotifications } from '@sequencehq/core-components'
import { TaxCategory } from '../../taxRates.types'
import { logError } from '@sequencehq/utils'

export function useUpdateTaxCategoryName() {
  const { displayNotification } = useNotifications()
  const queryClient = useApiQueryClient()

  const { mutateAsync: postNewTaxCategoryVersion } = useMutation(
    dashboardv99990101Client.postNewTaxCategoryVersion,
    {
      onSuccess: () => {
        // Invalidate both tax categories and avalara mappings queries to refresh the UI
        void queryClient.invalidateQueries(
          dashboardv99990101Client.getTaxCategories
        )
        void queryClient.invalidateQueries(
          dashboardv99990101Client.getAllTaxCategoriesWithAvalaraMappings
        )
      }
    }
  )

  return async (taxCategory: TaxCategory, newName: string) => {
    try {
      await postNewTaxCategoryVersion({
        id: taxCategory.id,
        body: {
          version: taxCategory.version + 1,
          name: newName,
          description: taxCategory.description,
          isPublished: true
        }
      })

      displayNotification('Tax category updated', {
        type: 'success'
      })
    } catch (error) {
      logError(error)
      displayNotification('Failed to update tax category', {
        type: 'error'
      })
    }
  }
}
